var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"waggon-wrapper"},[_c('div',{staticClass:"waggon color-3",style:(`${_vm.zoom
      ?
        `border-radius: calc(4px * ${_vm.zoom}) !important;
        margin: calc(2px * ${_vm.zoom});
        width: calc((var(--workpackage_width) + 4px) * ${_vm.zoom} * ${_vm.duration ? _vm.duration : 1});
        height: calc((var(--workpackage_height) + 4px) * ${_vm.zoom});`
      :
        `${_vm.duration
          ?
            `width: calc((var(--workpackage_width) + 4px) * var(--taktplan_zoom) * ${_vm.duration} +
            ${_vm.duration > 1
              ?
                `(2px * var(--taktplan_zoom) * 2 * ${_vm.duration - 1})`
              :
                '0px'});`
          :
            ''}`
    }
    ${_vm.dummy
      ?
        `border: solid calc(2px * var(--taktplan_zoom)) var(--v-color-3-base);
        background-color: var(--v-color-1-base) !important;`
      :
        ''
    }
    ${_vm.$store.state.View.show_taktplan_shadows
      ?
        `box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);`
      :
        ''}
    `)},[_c('div',{staticClass:"waggon-prepend"},[_vm._t("prepend")],2),_c('div',{staticClass:"waggon-grid",style:(`grid-template-columns: ${_vm.gridColumns}`)},[_vm._t("content",null,{"waggon":_vm.waggon,"easter_egg":_vm.easter_egg})],2),_c('div',{staticClass:"waggon-append"},[_vm._t("append")],2),_c('div',{staticClass:"waggon-badge"},[_vm._t("badge")],2)]),_vm._t("waggon-steps")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }